"use strict";
// write your code here
var body = document.querySelector("body");
var logo = document.querySelector(".logo");
var promise1 = new Promise(function(resolve, reject) {
    logo.addEventListener("click", function() {
        resolve();
    }, {
        once: true
    });
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        return reject(new Error("Promise was rejected!"));
    }, 3000);
});
promise1.then(function() {
    var div = document.createElement("div");
    div.classList.add("message");
    div.textContent = "Promise was resolved!";
    body.appendChild(div);
}).catch(function(errorMessage) {
    var div = document.createElement("div");
    div.classList.add("message");
    div.classList.add("error-message");
    div.textContent = errorMessage.message;
    body.appendChild(div);
});
promise2.then(function() {
    var div = document.createElement("div");
    div.classList.add("message");
    div.textContent = "Promise was resolved!";
    body.appendChild(div);
}).catch(function(errorMessage) {
    var div = document.createElement("div");
    div.classList.add("message");
    div.classList.add("error-message");
    div.textContent = errorMessage.message;
    body.appendChild(div);
});

//# sourceMappingURL=index.5585c321.js.map
